import styled from 'styled-components';
import SimpleButton from '@components/SimpleButton';

const StyledSimpleButton = styled(SimpleButton)`
  div > svg {
    width: 14px;
    height: 14px;
    margin-left: ${({ theme }) => theme.spacing(2)};
  }
`;

export default StyledSimpleButton;
